export default __webpack_public_path__ + "static/media/saas-icon.fe51010f.svg";